import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Narration, Narrator} from "./Shot";
import {host} from "./api";


export interface NarrationState {
    status: Status,
    error: string | null | undefined
}

const initialState: NarrationState = {
    status: Status.Idle,
    error: null,
}

export const saveNarration = createAsyncThunk('saveNarration', async (params: { projectId: number, shotId: number, narration: Narration }) => {
    const response = await axios.post(`${host}/shots/${params.shotId}/narrations`,
        params.narration,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})


export const saveNarrator = createAsyncThunk('saveNarrator', async (params: { projectId: number, narrator: Narrator }) => {
    const response = await axios.post(`${host}/narrators`,
        params.narrator,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteNarration = createAsyncThunk('deleteNarration', async (params: { projectId: number, narrationId: number }) => {
    const response = await axios.delete(`${host}/narrations/${params.narrationId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteNarrator = createAsyncThunk('deleteNarrator', async (params: { projectId: number, narrationId: number }) => {
    const response = await axios.delete(`${host}/narrations/${params.narrationId}/narrator`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const setNarrator = createAsyncThunk('setNarrator', async (params: { projectId: number, narrationId: number, narratorId: number }) => {
    const response = await axios.post(`${host}/narrations/${params.narrationId}/narrator/${params.narratorId}`,
        {},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const narrationSlice = createSlice({
    name: 'narrations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(saveNarration.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveNarration.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteNarration.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteNarration.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteNarrator.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteNarrator.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(setNarrator.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(setNarrator.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveNarrator.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveNarrator.fulfilled, (state, action) => {
                state.status = Status.Idle
            })

    }
})
export default narrationSlice.reducer;